import React from 'react'
import moment from 'moment'
import styled from 'styled-components'

const Today = styled.div`
  font-family: Gilroy;
  font-weight: 500;
  font-size: 1em;
  line-height: 150%;
  color: #52606c;
  border: 1px solid #dee2ec;
  border-radius: 12px;
  padding: 8px 15px;
  display: inline-block;
  text-transform: uppercase;
  margin: 0 18px;
  background: #ffffff;
`

export default function TodayTag(props) {
  return (
    <Today style={props.style}>
      today is {moment().format(props.format || 'MMM DD')}
    </Today>
  )
}
